import { Component, OnInit } from '@angular/core';
import {
  ParametersService,
  SubtitlesService,
  UpdateService
} from '../core';
import {StateService} from "@uirouter/core";
import {Language} from "../models";

@Component({
  selector: 'login-header',
  templateUrl: './login-header.component.html',
  styleUrls: ['./login-header.component.scss']
})
export class LoginHeaderComponent implements OnInit {
  showLanguagesList = false;
  windowHeight: number;
  externalLogin: string | null = null;
  constructor(
      public $state: StateService,
      public parameters: ParametersService,
      public subtitles: SubtitlesService,
      private update: UpdateService,
  ) {
  }

  ngOnInit(): void {
    this.windowHeight = window.innerHeight;
  }

  loginScreen(): void {
    this.$state.go('login', {selectedModuleHash: this.parameters.selectedModuleHash});
    this.update.stopInterval();
  }

  registrationScreen(): void {
    this.$state.go('registration', {selectedModuleHash: this.parameters.selectedModuleHash});
    this.update.stopInterval();
  }

  subtitle(id: number): string {
    return this.subtitles.setSubtitle(id);
  }

  toggleLanguagesList(): void {
    this.showLanguagesList = !this.showLanguagesList;
  }

  getSubtitles(langShortcut: Language): void {
    this.subtitles.getSubtitles(langShortcut);
  }
}
